import { render, staticRenderFns } from "./DNSRecordTypeCard.vue?vue&type=template&id=5e348ca4&scoped=true"
import script from "./DNSRecordTypeCard.vue?vue&type=script&lang=js"
export * from "./DNSRecordTypeCard.vue?vue&type=script&lang=js"
import style0 from "./DNSRecordTypeCard.vue?vue&type=style&index=0&id=5e348ca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e348ca4",
  null
  
)

export default component.exports